var _rect, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfrica(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 26,
    viewBox: "0 0 36 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16_1407)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16_1407",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16_1407)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_16_1407",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 3,
    width: 30,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 3H3V23H33V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_16_1407)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5686 1H1.4314V25H34.5686V1Z",
    fill: "#DB1F26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9999 2.99997H2.99988V7.99997H32.9999V2.99997Z",
    fill: "#253A7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9999 7.99997H2.99988V13H32.9999V7.99997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9999 13H2.99988V18H32.9999V13Z",
    fill: "#2A9747"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9999 18H2.99988V23H32.9999V18Z",
    fill: "#FDCD0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4999 2.99997H15.4999V23H20.4999V2.99997Z",
    fill: "#D31F35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90571 3.29895L9.45191 4.98035H11.2199L9.78951 6.01955L10.3359 7.70095L8.90571 6.66175L7.47531 7.70095L8.02151 6.01955L6.59131 4.98035H8.35931L8.90571 3.29895Z",
    fill: "#FDCD0A"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16_1407",
    x: 0,
    y: 0,
    width: 36,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16_1407"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16_1407",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfrica);
export default __webpack_public_path__ + "static/media/Africa.de1faa89550584bcefcb242e6fc59ab3.svg";
export { ForwardRef as ReactComponent };